import { render, staticRenderFns } from "./TaskDescription.vue?vue&type=template&id=cfeb2cac&scoped=true&"
import script from "./TaskDescription.vue?vue&type=script&lang=js&"
export * from "./TaskDescription.vue?vue&type=script&lang=js&"
import style0 from "./TaskDescription.vue?vue&type=style&index=0&id=cfeb2cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeb2cac",
  null
  
)

export default component.exports